module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-sm-12 header"
  }, [_c('router-link', {
    staticClass: "back-link material-icons",
    attrs: {
      "to": "/recipes"
    }
  }, [_vm._v("chevron_left")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.recipe.title))])], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recipe.title),
      expression: "recipe.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Add Recipe"
    },
    domProps: {
      "value": (_vm.recipe.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.recipe.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "mdl-button mdl-button--raised",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveRecipe()
      }
    }
  }, [_vm._v("Add Recipe")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-869f5612"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewRecipe.vue
// module id = 141
// module chunks = 0